jQuery(document).ready(function ($) {
	// Simple accordion functionality
	$('body').on('click', '.accordion__group button', function (e) {
		e.preventDefault();

		// If item clicked on is open, close it
		if ($(this).closest('.accordion__group').hasClass('active')) {
			$(this).closest('.accordion__group').removeClass('active');
			$(this).attr('aria-expanded', false);
			$(this)
				.closest('.accordion__group')
				.find('.accordion__copy')
				.slideUp();
		} else {
			// Otherwise, close all others and open the one clicked on
			$(this)
				.closest('.accordion__group')
				.siblings()
				.removeClass('active');
			$(this)
				.closest('.accordion__group')
				.siblings()
				.find('.accordion__copy')
				.slideUp();

			$(this)
				.closest('.accordion__group')
				.siblings()
				.find('.accordion__heading')
				.attr('aria-expanded', false);

			$(this).closest('.accordion__group').addClass('active');
			$(this).attr('aria-expanded', true);
			$(this)
				.closest('.accordion__group')
				.find('> .accordion__copy')
				.slideToggle();
		}
	});
});
